// extracted by mini-css-extract-plugin
module.exports = {"circle":"NotificationCircle_circle__nsiiu","circle_grey":"NotificationCircle_circle_grey__1Fyih","circle_number":"NotificationCircle_circle_number__3InXU"};